import React, { useState } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { DetailedTimeslot } from 'src/types';
import { useLocale, useTranslations } from 'next-intl';
import { LOCALE_DATE_FORMAT } from 'src/lib/constants';

type Props = {
  timeslots: DetailedTimeslot[];
  show: boolean;
  timeslotDate?: string;
  detailedTimeslotId?: number;
  onSelect?: (timeslot: DetailedTimeslot) => void;
  className?: string;
  titleClassName?: string;
  slotContainerClassName?: string;
};

const BookingTimeslotSelectorV2: React.FC<Props> = ({
  show,
  timeslots,
  timeslotDate,
  onSelect,
  detailedTimeslotId,
  className,
  titleClassName,
  slotContainerClassName
}) => {
  const locale = useLocale()
  const translation = useTranslations('components.BookingTimeslotSelectorV2')
  const UIDateFormat = LOCALE_DATE_FORMAT[locale].UIDateFormat
  const [selectedTimeslot, setSelectedTimeslot] = useState<DetailedTimeslot | undefined>(
    timeslots.find(o => o.id === detailedTimeslotId)
  );

  return (
    <div className={classNames(`${className || ''}`, { 'tw-hidden': !show })}>
      <div className={`tw-font-semibold tw-font-styleSans tw-text-xl md:tw-text-2xl tw-leading-none md:tw-leading-none tw-mb-3 ${titleClassName || ''}`}>
        {translation('selectTimeFor')} {dayjs(timeslotDate).format(UIDateFormat)}
      </div>

      <div className={`tw-flex tw-flex-wrap ${slotContainerClassName || ''}`}>
        {timeslots.map((timeslot) => (
          <div
            key={timeslot.id}
            className={classNames(
              'tw-inline-block tw-mr-1.5 tw-mb-1.5 tw-rounded-4xl tw-text-brand-navy tw-border tw-border-brand-navy hover:tw-bg-brand-green tw-py-1.5 tw-px-2.5 tw-leading-none tw-text-sm tw-cursor-pointer',
              {
                'tw-bg-white':
                  selectedTimeslot?.id !== timeslot.id,
              },
              { 'tw-bg-brand-green': selectedTimeslot?.id === timeslot.id }
            )}
            onClick={() => {
              typeof onSelect === 'function' && onSelect(timeslot);
              setSelectedTimeslot(timeslot);
            }}
          >
            {dayjs.utc(timeslot.startTime).format('h:mma')}
            {' - '}
            {dayjs.utc(timeslot.endTime).format('h:mma')}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookingTimeslotSelectorV2;
